export default __webpack_public_path__ + "static/media/bg.9da0fc99.svg";